import React, { Component } from 'react';
import './index.css';

class ProgressTraker extends Component {

    state = {
        finishStep: this.props.step,
        data: this.props.steps
    }
    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ finishStep: nextProps.step, data: nextProps.steps });
    }

    render() {
        return (
            <div className="container">
                <div className="progressbar">
                    {
                        this.state.data.map((post) =>
                            <span key={post.id} className={this.state.finishStep > post.id ? "active" : ""}>
                                <span className="progress-circle"></span>
                                <span className="step-text">{post.title}</span>
                            </span>
                        )
                    }
                </div>
            </div>

        );
    }
}
export default ProgressTraker;